import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'

export interface Props {
  id: string
  children?: () => void
  onSuccess: (data: string) => void
}

const GetContentsCustomScriptRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = TEST_CONFIG_SERVICE + '/custom_scripts/' + id + '/contents'

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      responseType='text'
      url={url}
    />
  )
}

export default GetContentsCustomScriptRequest
